/**
 * Internationalisation — français et anglais, au choix de l'utilisateur.
 *
 * Entièrement côté navigateur : rien à changer sur le serveur. Le choix est
 * gardé dans localStorage, et à défaut on suit la langue du navigateur.
 *
 * Ce que cela NE couvre PAS, volontairement : les messages renvoyés par l'API.
 * Les traduire demanderait que le backend renvoie un code en plus du texte.
 * Un message d'erreur peut donc apparaître dans l'autre langue — c'est le prix
 * de n'avoir rien à déployer côté serveur.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';

export const LANGUES = [
  { code: 'fr', libelle: 'Français' },
  { code: 'en', libelle: 'English' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    fallbackLng: 'en',
    supportedLngs: LANGUES.map((l) => l.code),
    // Une clé manquante affiche la clé elle-même, ce qui se repère tout de
    // suite. Un texte vide passerait inaperçu jusqu'en production.
    returnEmptyString: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mymdo_langue',
      caches: ['localStorage'],
    },
  });

export default i18n;
